//import {combineReducers} from 'redux';
import {combineReducers} from '@reduxjs/toolkit';

import {
    anagraficaRuoliReducer,
    authenticationReducer,
    breadcrumbReducer,
    configurationReducer,
    dataOraReducer,
    datiCastellettoReducer,
    datiRegistroReducer,
    docentiReducer,
    giustificativiReducer,
    individuiReducer,
    loadingOverlaysReducer,
    notifsReducer,
    pianificazioneCalendarioReducer,
    profiliOrariReducer,
    timbratureReducer,
    tipiGiustificativiReducer,
    tipoAttivitaReducer
} from './index';

import {corso_corsiStore} from "../slices/corso_corsiSlice";
import {validazioneSlice} from '../slices/validazioneSlice';
import {pianificazioniStore} from "../slices/pianificazioniSlice";
import serieReducer from '../slices/serieSlice';


const rootReducer = combineReducers({
    notifs: notifsReducer.notifsReducer,
    loadingOverlays: loadingOverlaysReducer.loadingOverlayReducer,
    corso: corso_corsiStore.reducer,
    tipoAttivita: tipoAttivitaReducer.tipoAttivitaReducer,
    pianificazione: pianificazioniStore.reducer,
    pianificazioneCalendario: pianificazioneCalendarioReducer.pianificazioneCalendarioReducer,
    dataOra: dataOraReducer.dataOraReducer,
    individui: individuiReducer.individuiReducer,
    timbrature: timbratureReducer.timbratureReducer,
    giustificativi: giustificativiReducer.giustificativiReducer,
    auth: authenticationReducer.authenticationReducer,
    docenti: docentiReducer.docentiReducer,
    tipiGiustificativi: tipiGiustificativiReducer.tipiGiustificativiReducer,
    datiRegistro: datiRegistroReducer.datiRegistroReducer,
    datiCastelletto: datiCastellettoReducer.datiCastellettoRedcuer,
    profiliOrari: profiliOrariReducer.profiliOrariReducer,
    validazione: validazioneSlice.reducer,
    anagraficaRuoli: anagraficaRuoliReducer.anagraficaRuoliReducer,
    breadcrumb: breadcrumbReducer.breadcrumbReducer,
    configurationFile: configurationReducer.configurationReducer,
    config: require('../store/configSlice').default,
    serie: serieReducer
});


export default rootReducer;
